import { ICreateDiarioObraParalisacoesUseCase } from "../../../presentation/useCases/create/create_diario_obra_paralisacoes_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// CreateDiarioObraParalisacoesUseCase


export class CreateDiarioObraParalisacoesUseCase implements ICreateDiarioObraParalisacoesUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async createDiarioObraParalisacoes(IdDiarioObras: number | null, HorarioInicio: string | null, HorarioFim: string | null, Motivo: string | null, Assunto: string | null, TempoParalisacao: string | null): Promise<void> {
    
    await this.repository.createDiarioObraParalisacoes(
      IdDiarioObras, HorarioInicio, HorarioFim, Motivo, Assunto, TempoParalisacao
    );
  }
}
